import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  AccordionComponent,
  AgentPlatformDetailComponent,
  AsideListNavigationComponent,
  BackToTopComponent,
  BannerCarouselComponent,
  BeyondCxDetailComponent,
  CardComponent,
  CardContainerComponent,
  ConfirmDialogComponent,
  ContactSalesComponent,
  DashboardCertificationsComponent,
  DashboardProgressComponent,
  DurationComponent,
  ElearningStaticComponent,
  EloquaFormComponent,
  ExternalUrlLoaderComponent,
  FeaturedVideosComponent,
  FeedbackComponent,
  FlexibleLearningListComponent,
  FooterComponent,
  HeaderMegaMenuComponent,
  HeaderMobileComponent,
  HeroBannerComponent,
  InformationBannerComponent,
  InformationTooltipComponent,
  InstructionsListComponent,
  LearningPlanTilesComponent,
  LegacySubscriptionTilesComponent,
  LoadingPageComponent,
  LoadingSpinnerComponent,
  LoginShortcutBannerComponent,
  ModalDialogComponent,
  NotificationBannerComponent,
  PagingComponent,
  PointillistDetailComponent,
  PrinterComponent,
  PromotedVideosComponent,
  RecommendedFoundationalCoursesComponent,
  RecommendedVideosComponent,
  RequestFormComponent,
  RouteButtonComponent,
  SearchInputComponent,
  SessionsComponent,
  StaticPageComponent,
  StepsComponent,
  SubmitBugComponent,
  SubscriptionAccordionComponent,
  SubscriptionListComponent,
  SubscriptionTilesComponent,
  TestimonialsComponent,
  TileLayoutComponent,
  TileVerticalComponent,
  ToggleSwitchButtonComponent,
  TrustedPartnersComponent,
  VideoContainerComponent,
  VideoSliderComponent,
} from './_index';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@app/pipes/pipes.module';
import { NguCarousel } from '@ngu/carousel';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxPrintModule } from 'ngx-print';
// import { TooltipModule } from '@cloudfactorydk/ng2-tooltip-directive';
import { TranslateModule } from '@ngx-translate/core';

const declarations = [
  AccordionComponent,
  AgentPlatformDetailComponent,
  AsideListNavigationComponent,
  BannerCarouselComponent,
  BackToTopComponent,
  BeyondCxDetailComponent,
  CardContainerComponent,
  ContactSalesComponent,
  ConfirmDialogComponent,
  DashboardProgressComponent,
  DashboardCertificationsComponent,
  ElearningStaticComponent,
  EloquaFormComponent,
  ExternalUrlLoaderComponent,
  FeaturedVideosComponent,
  FeedbackComponent,
  FlexibleLearningListComponent,
  FooterComponent,
  HeaderMegaMenuComponent,
  HeaderMobileComponent,
  HeroBannerComponent,
  InformationBannerComponent,
  InstructionsListComponent,
  LearningPlanTilesComponent,
  LoadingPageComponent,
  LoadingSpinnerComponent,
  LoginShortcutBannerComponent,
  ModalDialogComponent,
  NotificationBannerComponent,
  PagingComponent,
  PointillistDetailComponent,
  PrinterComponent,
  PromotedVideosComponent,
  RecommendedFoundationalCoursesComponent,
  RecommendedVideosComponent,
  RequestFormComponent,
  SessionsComponent,
  SearchInputComponent,
  StaticPageComponent,
  StepsComponent,
  SubscriptionAccordionComponent,
  SubscriptionListComponent,
  SubscriptionTilesComponent,
  LegacySubscriptionTilesComponent,
  SubmitBugComponent,
  TestimonialsComponent,
  TileLayoutComponent,
  TileVerticalComponent,
  ToggleSwitchButtonComponent,
  TrustedPartnersComponent,
  VideoContainerComponent,
  VideoSliderComponent,
];

const modules = [
  CardComponent,
  DurationComponent,
  FormsModule,
  InformationTooltipComponent,
  NgxPaginationModule,
  PipesModule,
  ReactiveFormsModule,
  RouteButtonComponent,
  RouterModule,
  TranslateModule,
];
@NgModule({
  imports: [CommonModule, NguCarousel, NgxPrintModule, ...modules],
  declarations: declarations,
  exports: [...declarations, ...modules],
})
export class ComponentsModule {}
